module.exports = __webpack_public_path__ + "static/media/virtualmirrorActive.dacc2c04.png";